import React from 'react';

const IconLogo = () => (
  <svg id="logo" xmlns="http://www.w3.org/2000/svg" role="img" viewBox="0 0 84 96">
    <title>Logo</title>

    <g transform="translate(-8 -2)">
      <g transform="translate(11 5)">
        {/* hex outline ------------------------------------------------ */}
        <polygon
          id="Shape"
          stroke="currentColor"
          strokeWidth="5"
          strokeLinecap="round"
          strokeLinejoin="round"
          points="39 0 0 22 0 67 39 90 78 68 78 23"
        />

        {/* letter ----------------------------------------------------- */}
        <text
          x="23"
          y="61"
          fill="currentColor"
          fontFamily="var(--font-sans, sans-serif)"
          fontSize="60"
          fontWeight="700">
          R
        </text>

        {/* ── original “B” path kept for reference ───────────────────
        <path
          d="M45.691667,45.15 C48.591667,46.1 50.691667,48.95 50.691667,52.2
             C50.691667,57.95 46.691667,61 40.291667,61 L28.541667,61 L28.541667,30.3
             L39.291667,30.3 C45.691667,30.3 49.691667,33.15 49.691667,38.65
             C49.691667,41.95 47.941667,44.35 45.691667,45.15 Z
             M33.591667,43.2 L39.241667,43.2 C42.791667,43.2 44.691667,41.85
             44.691667,38.95 C44.691667,36.05 42.791667,34.8 39.241667,34.8
             L33.591667,34.8 L33.591667,43.2 Z
             M33.591667,47.5 L33.591667,56.5 L40.191667,56.5 C43.691667,56.5
             45.591667,54.75 45.591667,52 C45.591667,49.2 43.691667,47.5
             40.191667,47.5 L33.591667,47.5 Z"
          fill="currentColor"
        />
        ───────────────────────────────────────────────────────────── */}
      </g>
    </g>
  </svg>
);

export default IconLogo;
